import React from 'react';
import { MainLayout } from 'layouts/MainLayout';
import { LocationScopedSettings } from 'components/settings/LocationScopedSettings';
import { IntegrationsSettings } from 'components/settings/IntegrationsSettings';
import { MERCHANT_MOBILE_SETTINGS } from 'config/routes';

export const IntegrationsSettingsPage: React.FC = () => (
    <MainLayout
        pageName="Integrations"
        pageDescription="Connect Pepper to third-party services."
        breadcrumbs={[{ label: 'Settings', url: MERCHANT_MOBILE_SETTINGS }]}
    >
        <LocationScopedSettings
            globalComponent={IntegrationsSettings}
            scopedComponent={IntegrationsSettings}
        />
    </MainLayout>
);
